import connect from './connect'
import ElementTotalPrints from './element_total_prints'

export default connect(ElementTotalPrints)
